<template>
    <div class="edit-user-groups-modal">
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
            label-width="150px"
        >
            <el-form-item
                :label="getVerbose('user_groups_edit_form_label_groups')"
                prop="groups"
            >

                <el-transfer
                    ref="groupTransfert"
                    v-model="form.groups"
                    :filter-placeholder="getVerbose('user_groups_edit_filter_placeholder')"
                    :data="groupsFormated"
                    :titles="[getVerbose('user_groups_edit_form_transfer_from'), getVerbose('user_groups_edit_form_transfer_to')]"
                    class="transfert-sized"
                    filterable
                >
                </el-transfer>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import schwartz from 'schwartz';

export default {

    components: {
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        groups: {
            type: Array,
            required: true,
        },
        getVerbose: {
            type: Function,
            required: true
        }
    },

    data (){
        let checkTransfertButtons = (rule, value, callback) => {
            let transfert = this.$refs.groupTransfert;
            if(transfert.leftChecked.length > 0 || transfert.rightChecked.length > 0 ){
                callback(new Error(this.getVerbose('user_groups_edit_validator_error')));
            }else{
                callback();
            }
        };
        return {
            form: {
                groups: [],
            },
            originGroups: [],
            addedGroups: [],
            deletedGroups: [],

            rules: {
                groups: [
                    { validator: checkTransfertButtons, trigger: 'blur' }
                ]
            }
        };
    },

    computed: {
        groupsFormated (){
            return schwartz(this.groups.map((group) => {
                return {
                    label: group.name,
                    key: group.uid,
                };
            }), (group) => {group.label;});
        },

        groupsWithUser (){
            return this.groups.filter((group) => {
                return group.members_uid.includes(this.user.uid);
            }).map((group) => group.uid);
        }
    },

    watch: {
        'form.groups' (val){
            // add item that has been added to user groups to array addedGroups
            for (let item of val){
                if(!this.originGroups.includes(item) && !this.form.addedGroups.includes(item)){
                    this.form.addedGroups.push(item);
                }
            }

            // add item that has been deleted to user groups to array deletedGroups
            for (let item of this.originGroups){
                if(!val.includes(item) && !this.form.deletedGroups.includes(item)){
                    this.form.deletedGroups.push(item);
                }
            }
            // check if an item has been added to user groups and removed later; in that case remove it from addedGroups
            for (let i = this.form.addedGroups.length - 1; i >= 0; --i){
                if(!val.includes(this.form.addedGroups[i])){
                    this.form.addedGroups.splice(i, 1);
                }
            }

            // check if an item has been removed to user groups and added later; in that case remove it from deletedGroups
            for (let i = this.form.deletedGroups.length - 1; i >= 0; --i){
                if(val.includes(this.form.deletedGroups[i])){
                    this.form.deletedGroups.splice(i, 1);
                }
            }
        }
    },

    mounted (){
        this.$set(this, 'form', {
            groups: this.groupsWithUser,
            uid: this.user.uid,
            url: this.user.url,
            addedGroups: [],
            deletedGroups: [],
        });
        this.$set(this, 'originGroups', this.groupsWithUser);
    },

    methods: {

    },
};
</script>

<style lang="scss">
.manage-group-modal {
    overflow-y: scroll;
    @media (min-width: 500px) {
        overflow-y: auto;
    }
}
.el-message-box {
    width: 80% !important;
}
.edit-user-groups-modal{
    .el-alert{
        display: inline;
        padding: 11px;
        margin-left: 15px;
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/usersManagement/user/edit-user-groups-modal.vue